import { getApi, IGet } from '../services/getApi';
import { useQuery, UseQueryResult, QueryKey, UseQueryOptions } from '@tanstack/react-query';

interface IGetMutation<TData, TError> {
	queryKey: QueryKey;
	options?: UseQueryOptions<TData, TError>;
	request: IGet;
}

const useGet = <TData, TError = unknown>({
	queryKey,
	options,
	request,
}: IGetMutation<TData, TError>): UseQueryResult<TData, TError> => {
	return useQuery(queryKey, () => getApi<TData>({ ...request }), options);
};

export { useGet };
